import {Component, ViewEncapsulation} from '@angular/core';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {ImmediatelyRenderedMessageComponent} from '../immediately-rendered-message-component';

@Component({
    templateUrl: './typing-indicator.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TypingIndicatorComponent extends ImmediatelyRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'typingindicator';
}
